var ETechnicalDefinitionType = /*#__PURE__*/ function(ETechnicalDefinitionType) {
    ETechnicalDefinitionType["Http"] = "http";
    ETechnicalDefinitionType["Local"] = "local";
    ETechnicalDefinitionType["Session"] = "session";
    ETechnicalDefinitionType["IndexedDb"] = "indexedDb";
    return ETechnicalDefinitionType;
}(ETechnicalDefinitionType || {});
var ETechnicalDefinitionHostType = /*#__PURE__*/ function(ETechnicalDefinitionHostType) {
    /**
     * nip.io
     */ ETechnicalDefinitionHostType["Main"] = "main";
    /**
     * .nip.io
     */ ETechnicalDefinitionHostType["MainPlusSubDomains"] = "main+subdomains";
    /**
     * feat.nip.io
     */ ETechnicalDefinitionHostType["Current"] = "current";
    /**
     * https://feat.nip.io
     */ ETechnicalDefinitionHostType["CurrentPlusProtocol"] = "current+protocol";
    /**
     * .feat.nip.io
     */ ETechnicalDefinitionHostType["CurrentPlusSubDomains"] = "current+subdomains";
    return ETechnicalDefinitionHostType;
}(ETechnicalDefinitionHostType || {});
var ETechnicalDefinitionDurationUnit = /*#__PURE__*/ function(ETechnicalDefinitionDurationUnit) {
    ETechnicalDefinitionDurationUnit["Seconds"] = "s";
    ETechnicalDefinitionDurationUnit["Minutes"] = "m";
    ETechnicalDefinitionDurationUnit["Hours"] = "h";
    ETechnicalDefinitionDurationUnit["Days"] = "d";
    ETechnicalDefinitionDurationUnit["Months"] = "mo";
    ETechnicalDefinitionDurationUnit["Years"] = "y";
    return ETechnicalDefinitionDurationUnit;
}(ETechnicalDefinitionDurationUnit || {});
export { ETechnicalDefinitionType, ETechnicalDefinitionHostType, ETechnicalDefinitionDurationUnit };
